<template>
  <v-row class="refer-friendbox">
    <v-col class="text-box">
      <h2>Refer & Earn Rewards Points</h2>
      <p>1. Send a referral link to your friends via Email / WhatsApp / Telegram.</p>
      <p>2. Get 100 reward points on every successful reference.</p>
      <p>3. Reward points will be credited once payment is made towards subscription.</p>
      <p>4. Reward points can be redeemed against subscription renewal fee.</p>
      <p>5. Refer Terms & Conditiond below.</p>
      <form class="login-form-box">
      <v-text-field 
          v-model="referral_code_url"
          label="Referral Link"
          placeholder = "Referral Link"
          readonly
        >
        </v-text-field>
        <div class="bottombox">
          <div class="refer-btnbox">
            <v-btn
              class="blue-btn btn"
              @click="socialOpen"
            >
            REFER NOW
            </v-btn>
            <span class="how-work" @click="dialog = !dialog">Terms & Conditions</span>
          </div>
            <span>Please go through reward points</span>
          <div class="social-icon show" v-if="showClass">
            <WhatsApp :url="referral_code_url" :title="title" scale="9"></WhatsApp>
            <Telegram :url="referral_code_url" :title="title" scale="9"></Telegram>
            <Email :body="body" :url="referral_code_url" :title="title" scale="9"></Email>
          </div>
          <div class="social-icon" v-if="!showClass">
            <WhatsApp :url="referral_code_url" :title="title" scale="9"></WhatsApp>
            <Telegram :url="referral_code_url" :title="title" scale="9"></Telegram>
            <Email :url="referral_code_url" :title="title" :body="body" scale="9"></Email>
          </div>
        </div>
      </form>
    </v-col>
    <div class="text-center">
      <v-dialog
        v-model="dialog"
        width="700"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Terms & Conditions
          </v-card-title>
          <v-card-text>
           <ol style="margin-top:10px;">
            <li>You can earn reward points on your subscription to Nimeya and on referring members.</li>
            <li>Referral is only applicable for new subscription upon payment of subscription fees.</li>
            <li>You will get 49/99/149 reward points once you subscribe to Nimeya for Silver/Gold &amp; Platinum subscriptions respectively.</li>
            <li>For every successful reference you will earn 100 rewards points.</li>
            <li>Each reward point is equivalent to Indian Rupee one.</li>
            <li>Reward points can only be redeemed on Nimeya products and services.</li>
            <li>Reward points cannot be encashed.</li>
            <li>The Company has the right to change the rupee value of reward points at a future date.</li>
            <li>Change in rupee value of reward points will be intimated in advance.</li>
            <li>Reward points will be credited to your account after 15 days post realization of the full payment towards subscription.</li>
            <li>You can redeem your reward points against subsequent renewal fees and/or purchasing top-up services as and when offered.</li>
            <li>Unutilized reward points will be carried forward.</li>
            <li>Reward points are non-transferable.</li>
            <li>Balance reward points, if any, will lapse on discontinuance of the subscription of Nimeya.</li>
            <li>The terms and conditions can be changed by the Company from time to time.</li>
            <li>The above terms & conditions has to be read in conjunction with the Privacy Policy & Terms of Use.</li>
          </ol>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
  <!--   <v-col class="image-box">
      <v-img
        :src="group_img"
        :lazy-src="group_img"
      >
    </v-img>
    </v-col> -->
  </v-row>
</template>
<script>
  import { WhatsApp, Telegram, Email } from 'vue-socialmedia-share';

  // usage in local component

  export default {
    components: {
    WhatsApp,
    Telegram,
    Email,
  },
  data () {
      return { 
        dialog:false,
        subject:'',
        referral_code_url: '' ,
        title:'Click on this link to use the promo code.',
        showClass:false,
        group_img:process.env.VUE_APP_ROOT_ICONS_URL + 'Group_162905@2x.png',
        refer_img:process.env.VUE_APP_ROOT_ICONS_URL + 'refer-icon.png',
        body:'',    
      }
    },
    created (){
      this.referralLink();
    },
 methods:{
  showTermsCondition(){
    window.open('https://nimeya.ai/terms-and-conditions/','','width=900,height=500');
  },
  socialOpen(){
    if (this.showClass == false) {
      this.showClass = true;
    }else{
      this.showClass = false;
    }
  },
  referralLink(){
    this.referral_code_url = window.location.origin+'=' +this.$store.getters.getProfileDetail.data.referral_code;
    let user_name= this.$store.getters.getProfileDetail.data.name;
    this.body = `Nimeya.ai- Apna Investometer

This is an invitation from `+user_name+` to join nimeya.ai. A personal financial wellness app that empowers you to ensure your financial wellbeing by digitally recording analyzing and tracking all your investments & liabilities and aligning the same with your financial goals.

Your REWARDS POINTS* is waiting. All you have to do is to make the subscription payment. You can also refer your friends & colleagues and earn REWARD POINTS. 

*Condition apply `+'                                                                                                                                                                                                                                                                                                   '
+this.referral_code_url;
    // this.referral_code_url = 'https://nimeya.page.link/';
    return this.referral_code_url;
  }
 }
};
</script>